const REGION_CODES_BY_NAME: Readonly<Record<string, string>> = {
  alabama: 'AL',
  alaska: 'AK',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  'district of columbia': 'DC',
  florida: 'FL',
  georgia: 'GA',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  'west virginia': 'WV',
  wisconsin: 'WI',
  wyoming: 'WY',
  'american samoa': 'AS',
  guam: 'GU',
  'northern mariana islands': 'MP',
  'puerto rico': 'PR',
  'us virgin islands': 'VI',
  'u s virgin islands': 'VI',
  'virgin islands': 'VI',
  alberta: 'AB',
  'british columbia': 'BC',
  manitoba: 'MB',
  'new brunswick': 'NB',
  'newfoundland and labrador': 'NL',
  newfoundland: 'NL',
  'northwest territories': 'NT',
  'nova scotia': 'NS',
  nunavut: 'NU',
  ontario: 'ON',
  'prince edward island': 'PE',
  quebec: 'QC',
  saskatchewan: 'SK',
  yukon: 'YT',
};

const REGION_CODES = new Set(Object.values(REGION_CODES_BY_NAME));

function regionCodeOfPart(part: string): string | null {
  const key = part
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z]+/g, ' ')
    .trim();
  const code = key.replace(/ /g, '').toUpperCase();
  if (code.length === 2 && REGION_CODES.has(code)) {
    return code;
  }
  return REGION_CODES_BY_NAME[key] ?? null;
}

/**
 * Returns the 2-letter code of a US state, DC, US territory, or Canadian
 * province or territory, given its code or full name in any case, spacing or
 * punctuation (`'N.Y.'`, `'new  york '`, `'Illinois (IL)'`,
 * `'NY - New York'`). Returns `null` for anything else, including
 * non-strings from raw legacy data.
 */
export function regionCode(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  for (const part of [value, ...value.split(/[()\-,/]/)]) {
    const code = regionCodeOfPart(part);
    if (code) {
      return code;
    }
  }
  return null;
}
